import { type ReactNode } from 'react';
import { Wallet } from 'lucide-react';
import type { Cfg } from '../hooks/use-settings-state';
import { SettingsCard } from './settings-card';
import { NumField, SelField } from './settings-field';

type Props = { cfg: Cfg; set: (k: keyof Cfg, v: string | number) => void };

const DAYS = [
  { value: 0, label: 'Domingo' },
  { value: 1, label: 'Lunes' },
  { value: 2, label: 'Martes' },
  { value: 3, label: 'Miércoles' },
  { value: 4, label: 'Jueves' },
  { value: 5, label: 'Viernes' },
  { value: 6, label: 'Sábado' },
];

function MinimumFields({ cfg, set }: Props): ReactNode {
  return (
    <>
      <NumField
        label="Mínimo para liquidar"
        value={cfg.payment_threshold}
        onChange={(v) => set('payment_threshold', v)}
        unit="$"
        tip="Acumulado mínimo para generar pago el día de pago"
      />
      <NumField
        label="Mínimo liquidación forzosa"
        value={cfg.minimum_payout_banned}
        onChange={(v) => set('minimum_payout_banned', v)}
        unit="$"
        tip="Acumulado mínimo para pagar a un colector baneado. Por debajo, no se liquida"
      />
    </>
  );
}

function PaymentFields({ cfg, set }: Props): ReactNode {
  return (
    <>
      <MinimumFields cfg={cfg} set={set} />
      <SelField
        label="Día de pago"
        value={cfg.payment_day_of_week}
        onChange={(v) => set('payment_day_of_week', +v)}
        options={DAYS}
      />
    </>
  );
}

export function PaymentsCard({ cfg, set }: Props): ReactNode {
  return (
    <SettingsCard
      icon={<Wallet size={16} />}
      title="Pagos"
      subtitle="Umbral de liquidación y día de pago semanal"
    >
      <PaymentFields cfg={cfg} set={set} />
    </SettingsCard>
  );
}
